import ZImage from './ZImage.vue'
export default ZImage
